import React, { useState } from 'react';
import { LogOut, Edit, BarChart3, Settings } from 'lucide-react';
import ContentEditor from './ContentEditor';
import AnalyticsDashboard from './AnalyticsDashboard';
import AdminSettings from './AdminSettings';

const AdminDashboard = ({ user }) => {
  const [activeTab, setActiveTab] = useState('analytics');

  const handleLogout = async () => {
    try {
      const backendUrl = process.env.REACT_APP_BACKEND_URL;
      await fetch(`${backendUrl}/api/auth/logout`, {
        method: 'POST',
        credentials: 'include'
      });
    } catch (error) {
      console.error('Logout error:', error);
    }
    window.location.href = '/admin/login';
  };

  return (
    <div className="min-h-screen bg-stone-100">
      {/* Header */}
      <header className="bg-stone-900 text-white">
        <div className="container mx-auto px-4 py-4 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <span className="text-xl">⚡</span>
            <div>
              <h1 className="font-bold">@techbaenae Admin</h1>
              <p className="text-xs text-stone-400">{user?.email}</p>
            </div>
          </div>
          <button
            onClick={handleLogout}
            className="flex items-center gap-2 text-stone-400 hover:text-white transition-colors"
            data-testid="logout-btn"
          >
            <LogOut className="w-4 h-4" />
            Logout
          </button>
        </div>
      </header>

      {/* Tab Navigation */}
      <div className="bg-white border-b border-stone-200">
        <div className="container mx-auto px-4">
          <nav className="flex gap-1">
            <button
              onClick={() => setActiveTab('analytics')}
              data-testid="tab-analytics"
              className={`px-4 py-3 flex items-center gap-2 border-b-2 transition-colors ${
                activeTab === 'analytics'
                  ? 'border-teal-500 text-teal-600'
                  : 'border-transparent text-stone-500 hover:text-stone-900'
              }`}
            >
              <BarChart3 className="w-4 h-4" />
              Analytics
            </button>
            <button
              onClick={() => setActiveTab('content')}
              data-testid="tab-content"
              className={`px-4 py-3 flex items-center gap-2 border-b-2 transition-colors ${
                activeTab === 'content'
                  ? 'border-teal-500 text-teal-600'
                  : 'border-transparent text-stone-500 hover:text-stone-900'
              }`}
            >
              <Edit className="w-4 h-4" />
              Content
            </button>
            <button
              onClick={() => setActiveTab('settings')}
              data-testid="tab-settings"
              className={`px-4 py-3 flex items-center gap-2 border-b-2 transition-colors ${
                activeTab === 'settings'
                  ? 'border-teal-500 text-teal-600'
                  : 'border-transparent text-stone-500 hover:text-stone-900'
              }`}
            >
              <Settings className="w-4 h-4" />
              Settings
            </button>
          </nav>
        </div>
      </div>

      {/* Content */}
      <main className="container mx-auto px-4 py-6">
        {activeTab === 'analytics' && <AnalyticsDashboard />}
        {activeTab === 'content' && <ContentEditor />}
        {activeTab === 'settings' && <AdminSettings user={user} />}
      </main>
    </div>
  );
};

export default AdminDashboard;
